import { createAlgoliaFilters, AlgoliaFilterOperator } from './create-algolia-filters.js';
import { getProductAttributesByFacets } from './get-product-attributes-from-facets.js';

/**
 * getAlgoliaFilters
 * Returns a subset of the algolia search paramaters.
 * This function returns the `filters` and the `optionalFilters`
 */ const getGraphAlgoliaFilters = (product, activeVariant, facets, activeSku, locale)=>{
    /**
   * Get all the sku's from the product
   * Create a filter string that excludes these skus from the result e.g:
   * `NOT masterVariant.sku:sku1 AND NOT masterVariant.sku:sku2`
   */ const masterVariantSku = {
        id: 'masterVariant.sku',
        value: activeSku
    };
    const variantSkus = product.variants.map((variant)=>({
            id: 'masterVariant.sku',
            value: variant.sku
        })
    ).filter((v)=>v.value !== masterVariantSku.value
    );
    const excludedSkus = createAlgoliaFilters([
        masterVariantSku,
        ...variantSkus
    ], AlgoliaFilterOperator.AND_NOT, AlgoliaFilterOperator.NOT);
    /**
   * Retrieve all the attributes from the product
   * The product attributes are checked against the facets,
   * if they exist in the facets, they will be returned.
   */ const attributes = getProductAttributesByFacets(facets, activeVariant.specifications, locale);
    /**
   *  Create strict filters, if there are no strict filters, use only the skus
   */ const strictAttributes = attributes.filter((attribute)=>attribute.type === 'strict'
    );
    const filters = strictAttributes.length > 0 ? `${createAlgoliaFilters(strictAttributes, AlgoliaFilterOperator.AND)} ${AlgoliaFilterOperator.AND} ${excludedSkus}` : excludedSkus;
    /**
   *  Create optional filters
   */ const optionalAttributes = attributes.filter((attribute)=>attribute.type === 'optional'
    );
    const optionalFilters = createAlgoliaFilters(optionalAttributes);
    return {
        filters,
        optionalFilters
    };
};

export { getGraphAlgoliaFilters };
//# sourceMappingURL=get-graph-algolia-filters.js.map
